import React from 'react';
import clsx from 'clsx';
import { Alert, Button, Card, CardContent, CardTitle } from '@shared/components';
import type { Product, RejectionReason } from '../../types/products.types';
import { formatRejectionReason } from '../../utils/formatRejectionReason';

const CARD_CLASSES = 'flex h-full w-full flex-col justify-between hover:bg-mp-background';
const SELECTED_CARD_CLASSES = 'border-mp-primary ring-1 ring-mp-primary';

interface ProductCardProps {
    product: Product;
    onSelectProduct: (product: Product) => void;
    isSelected?: boolean;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product, onSelectProduct, isSelected }) => {
    const failedRules: RejectionReason[] =
        product.eligibility_result && !product.eligibility_result.passed
            ? product.eligibility_result.evaluations.filter((e) => e.result === 'fail')
            : [];

    return (
        <Card className={clsx(CARD_CLASSES, isSelected && SELECTED_CARD_CLASSES)}>
            <CardContent className="flex flex-auto flex-col">
                <CardTitle>{product.name}</CardTitle>
                <p className="grow text-sm">{product.description}</p>

                <ul className="mt-2 text-sm list-disc list-inside space-y-1 flex-grow">
                    {product.features?.map((f, i) => (
                        <li key={i}>{f}</li>
                    ))}
                </ul>

                {failedRules.length > 0 && (
                    <Alert variant="warning" role="note" className="mt-2 text-xs">
                        <div>
                            <p className="font-semibold mb-1">Eligibility warnings:</p>
                            <ul className="list-disc list-inside space-y-0.5">
                                {failedRules.map((r, i) => (
                                    <li key={i}>{formatRejectionReason(r)}</li>
                                ))}
                            </ul>
                        </div>
                    </Alert>
                )}

                <div className="mt-auto">
                    {product.price && (
                        <p className="text-xl font-bold">{product.price}</p>
                    )}
                    <div className="mt-2 flex flex-wrap items-start justify-end gap-2">
                        <Button size="xs" onClick={() => onSelectProduct(product)}>
                            Select
                        </Button>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
